"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function eop(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.0355 21L7.02454 10.3027L5.40454 17.6827L11.0355 21ZM12.09 3.12823L7.69279 8.47724L12.09 19.7145L16.5128 8.47724L12.09 3.12823ZM13.17 21L17.1818 10.3027L18.7755 17.6827L13.17 21Z", fill: color }),
        React.createElement("path", { d: "M10.9455 20.9359L6.93451 10.2386L5.31451 17.6186L10.9455 20.9359ZM12 3.06415L7.60276 8.41315L12 19.6504L16.4228 8.41315L12 3.06415ZM13.08 20.9359L17.0918 10.2386L18.6855 17.6186L13.08 20.9359Z", fill: color }));
}
exports["default"] = eop;
//# sourceMappingURL=eop.js.map